import { WebMercatorViewport } from '@deck.gl/core/typed';
import { Port } from 'ais-facade-api/api';
import styles from './PortsTooltips.module.scss';
export const PortsTooltips = ({ ports, viewState }: { ports: Port[]; viewState: any }) => {
  const viewport = new WebMercatorViewport({ ...viewState });

  const tooltips = ports.map((port: Port) => {
    if (typeof port.lat === 'number' && typeof port.lon === 'number') {
      const projection = viewport.project([port.lon, port.lat]);
      return (
        <div
          key={port.key}
          className={styles.tooltip}
          style={{
            left: projection[0],
            top: projection[1] + 8,
          }}
        >
          {port.name}
        </div>
      );
    }
  });
  return viewState.zoom > 8 ? <>{tooltips}</> : null;
};
